//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { IHttpService, IPromise } from 'angular';
import { IPromiseService } from 'pinsights-js-shared';

import GaProfileId from '@models/GaProfileId';

const curalate = angular.module('curalate');

const BASE_URL_PIXEL = '/api/settings/pixel';
const BASE_URL_GA = '/api/settings/ga';
const BASE_URL_ADOBE = '/api/settings/adobe';

export interface ITrackingPixelDto {
  pixelId: number;
  isActive: boolean;
}

export interface IGaProfile {
  // TODO: Is one of these a GaProfileId?
  id: string;
  account_id: string;
  web_property_id: string;
  name: string;
  label: string;
  timezone: string;
  currency: string;
  ecommerce_tracking?: boolean;
  enhanced_ecommerce_tracking?: boolean;
  ecommerce_enabled: boolean;
}

export interface IGASettingsInfoDto {
  currentProfileId?: string;
  profileOptions: IGaProfile[];
}

export interface IAdobeSettingsInfoDto {
  isConnected: boolean;
  environmentOptions: {
    value: string;
    name: string;
  }[];
}

export interface IOmnitureCredentials {
  username: string;
  sharedSecret: string;
  environment: string;
  suiteReportId: string;
}

export class AnalyticsSettingsService {
  constructor(
    private readonly $http: IHttpService,
    private readonly PromiseService: IPromiseService,
  ) {}

  // Curalate Pixel
  public getPixel(): IPromise<ITrackingPixelDto> {
    return this.PromiseService.processHttpResponse(
      this.$http.get(BASE_URL_PIXEL),
    );
  }

  // Google Analytics
  public getGASettings(): IPromise<IGASettingsInfoDto> {
    return this.PromiseService.processHttpResponse(this.$http.get(BASE_URL_GA));
  }

  public getGAOAuthURL(): IPromise<{ url?: string }> {
    return this.PromiseService.processHttpResponse(
      this.$http.get(`${BASE_URL_GA}/oauth`),
    );
  }

  public deauthGAAccount(): IPromise<void> {
    return this.PromiseService.processHttpResponse(
      this.$http.delete(`${BASE_URL_GA}/deauth`),
    );
  }

  public updateGAProfile(profileId: GaProfileId): IPromise<void> {
    return this.PromiseService.processHttpResponse(
      this.$http.put(`${BASE_URL_GA}/profile/${profileId}`, undefined),
    );
  }

  // Adobe/Omniture
  public getOmnitureSettings(): IPromise<IAdobeSettingsInfoDto> {
    return this.PromiseService.processHttpResponse(
      this.$http.get(BASE_URL_ADOBE),
    );
  }

  public connectOmniture(credentials: IOmnitureCredentials): IPromise<void> {
    return this.PromiseService.processHttpResponse(
      this.$http.post(`${BASE_URL_ADOBE}/account`, credentials),
    );
  }

  public disconnectOmniture(): IPromise<void> {
    return this.PromiseService.processHttpResponse(
      this.$http.delete(`${BASE_URL_ADOBE}/account`),
    );
  }
}
curalate.service('AnalyticsSettingsService', [
  '$http',
  'PromiseService',
  AnalyticsSettingsService,
]);
